import { LogLevelDesc } from 'loglevel';

export const SHOULD_SHOW_FILTERS_ON_SHOPS = process.env.NEXT_PUBLIC_SHOULD_SHOW_FILTERS_ON_SHOPS == 'true';

export const SHOULD_SHOW_RETURNABLE_ACCESSORIES = process.env.NEXT_PUBLIC_SHOULD_SHOW_RETURNABLE_ACCESSORIES == 'true';

export const SHOULD_SHOW_LOYALTY_PROGRAM = process.env.NEXT_PUBLIC_SHOULD_SHOW_LOYALTY_PROGRAM == 'true';

export const SHOULD_SHOW_PAYMENT = process.env.NEXT_PUBLIC_SHOULD_SHOW_PAYMENT == 'true';

export const SHOULD_SHOW_STRIPE_CONFIGURATION = process.env.NEXT_PUBLIC_SHOULD_SHOW_STRIPE_CONFIGURATION == 'true';

export const SHOULD_SHOW_HOME_INFO_BANNER = process.env.NEXT_PUBLIC_SHOULD_SHOW_HOME_INFO_BANNER == 'true';

export const SHOULD_SHOW_SHOPS_WITHOUT_BOOMERANG =
  process.env.NEXT_PUBLIC_SHOULD_SHOW_SHOPS_WITHOUT_BOOMERANG == 'true';

export const BOOMERANG_PREMIUM_PLAN_ID = Number(process.env.NEXT_PUBLIC_BOOMERANG_PREMIUM_PLAN_ID) || 2;

export const APP_IMAGES_URL = process.env.NEXT_PUBLIC_APP_IMAGES_URL;

export const APP_URL = process.env.NEXT_PUBLIC_APP_URL;

export const WEBSITE_URL = process.env.NEXT_PUBLIC_WEBSITE_URL;

/**
 * !! Warning : if you modify this constant, you also need to modify it in backend to avoid inconsistencies
 */
export const ORDER_PROCESSING_RETURNABLE_ACCESSORIES_FEE_FIXED_AMOUNT = 1.99;
export const ORDER_PROCESSING_RETURN_EXPIRATION_DAYS = 7;
export const ORDER_PROCESSING_RETURNABLE_ACCESSORIES_FEE_AMOUNT_OFF = 1.99;
export const ORDER_PROCESSING_RETURNABLE_ACCESSORIES_FEE_AMOUNT_OFF_EXPIRATION_DATE = null;
export const BOOMERANG_PREMIUM_RETURNABLE_ACCESSORIES_DISCOUNT_PERCENTAGE_OFF = 0;

export const IS_MAINTENANCE_MODE = process.env.NEXT_PUBLIC_SHOULD_SHOW_MAINTENANCE_PAGE == 'true';
export const LOG_LEVEL = (process.env.NEXT_PUBLIC_LOG_LEVEL as LogLevelDesc) || 'error';

export const RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
